export const formatCurrency = (amount, currency, convertAmount) => {
  const locales = {
    USD: "en-US",
    VND: "vi-VN",
    EUR: "de-DE",
    JPY: "ja-JP",
    CNY: "zh-CN",
    KRW: "ko-KR",
    THB: "th-TH",
  };

  const currencySymbols = {
    USD: "USD",
    VND: "VND",
    EUR: "EUR",
    JPY: "JPY",
    CNY: "CNY",
    KRW: "KRW",
    THB: "THB",
  };

  const convertedAmount = convertAmount(amount, currency);

  return new Intl.NumberFormat(locales[currency] || "vi-VN", {
    style: "currency",
    currency: currencySymbols[currency] || "VND",
    maximumFractionDigits: 0,
  }).format(convertedAmount);
};
